/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ open: NonNullable<unknown>, time: NonNullable<unknown> }} Workout_Live_Forgotten_LeadInputs */

const en_us2_workout_live_forgotten_lead = /** @type {(inputs: Workout_Live_Forgotten_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This workout has been open for ${i?.open}. The last set was at ${i?.time}.`)
};

const pt_br2_workout_live_forgotten_lead = /** @type {(inputs: Workout_Live_Forgotten_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esse treino está aberto há ${i?.open}. A última série foi às ${i?.time}.`)
};

const es_419_workout_live_forgotten_lead = /** @type {(inputs: Workout_Live_Forgotten_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este entrenamiento lleva ${i?.open} abierto. La última serie fue a las ${i?.time}.`)
};

const pt_pt2_workout_live_forgotten_lead = /** @type {(inputs: Workout_Live_Forgotten_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este treino está aberto há ${i?.open}. A última série foi às ${i?.time}.`)
};

const fr_fr2_workout_live_forgotten_lead = /** @type {(inputs: Workout_Live_Forgotten_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette séance est ouverte depuis ${i?.open}. La dernière série était à ${i?.time}.`)
};

const de_de2_workout_live_forgotten_lead = /** @type {(inputs: Workout_Live_Forgotten_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Training ist seit ${i?.open} offen. Der letzte Satz war um ${i?.time}.`)
};

const it_it2_workout_live_forgotten_lead = /** @type {(inputs: Workout_Live_Forgotten_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo allenamento è aperto da ${i?.open}. L'ultima serie è stata alle ${i?.time}.`)
};

/**
* | output |
* | --- |
* | "This workout has been open for {open}. The last set was at {time}." |
*
* @param {Workout_Live_Forgotten_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_lead = /** @type {((inputs: Workout_Live_Forgotten_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_lead(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_lead(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_lead(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_lead(inputs)
	return en_us2_workout_live_forgotten_lead(inputs)
});
export { workout_live_forgotten_lead as "workout-live.forgotten_lead" }